import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ReactNode, useMemo } from "react";
import { stripeElementsAppearance } from "./stripeElementsAppearance";

export const StripeProvider = ({
  children,
  stripeAccountId,
  amount,
}: {
  children: ReactNode;
  stripeAccountId: string | undefined;
  amount: number;
}) => {
  const stripePromise = useMemo(() => {
    return loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || "", {
      stripeAccount: stripeAccountId,
    });
  }, [stripeAccountId]);

  const canUseStripe = !!stripeAccountId && amount > 0;

  if (canUseStripe) {
    return (
      <Elements
        stripe={stripePromise}
        options={{
          mode: "payment",
          amount,
          currency: "gbp",
          setup_future_usage: "on_session",
          allowedPaymentMethodTypes: ["card"],
          appearance: stripeElementsAppearance,
        }}
      >
        {children}
      </Elements>
    );
  }

  return children;
};
